import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Paper,
  Link,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Divider,
  Grid,
  TextField,
  Button,
  Snackbar,
  Alert, Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { db , storage} from "./firebase";
import {  collection, addDoc,getDocs, deleteDoc, doc, query, where,  Timestamp } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { useNavigate } from "react-router-dom"; 
import paidIcon from "./paid.png";
import * as XLSX from "xlsx";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";
import { getDisplayStatus } from "./utils/statusLabels";
import { showBuiltIn } from "./utils/accountBuiltIns";
const AdminDashboard = () => {
  const [orders, setOrders] = useState([]);
    const navigate = useNavigate(); 
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState([]);
const [selectedStatus, setSelectedStatus] = useState([]);
  const [selectedGovernorate, setSelectedGovernorate] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [paymentMethodFilter, setPaymentMethodFilter] = useState([]);
  const [paymentFilter, setPaymentFilter]= useState([]);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [activeStatFilter, setActiveStatFilter] = useState(null); // null | "all" | "done" | "inProgress"
const [selectedOrderType, setSelectedOrderType]  = useState([]);
const [saleAccountFilter, setSaleAccountFilter] = useState("الكل");
const [archivedOrders, setArchivedOrders] = useState([]);

const getPackagingDate = (order) => {
  const history = Array.isArray(order.history) ? order.history : [];
  if (!history.length) return null;

  const sorted = [...history].sort(
    (a, b) => (a.timestamp?.toMillis?.() || 0) - (b.timestamp?.toMillis?.() || 0)
  );

  for (let i = 0; i < sorted.length; i++) {
    const st = sorted[i]?.status || "";

    if (
      st === "عند برهان - تغليف" ||
      st === "تغليف"
    ) {
      return toDateSafe(sorted[i]?.timestamp);
    }
  }

  return null;
};
const dashboardBoxStyle = {
  height: 65,
  borderRadius: 2,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  fontWeight: 500,
  fontSize: "13px",
  color: "#fff",
  cursor: "pointer",
  boxShadow: 1,
  transition: "all 0.2s ease",
  "&:hover": {
    transform: "translateY(-2px)",
    boxShadow: 3,
  },
};
// 🔴 أنواع مشاكل الفيدباك السلبي (تعريف ثابت)
const NEGATIVE_ISSUE_TYPES = [
  { key: "frame", label: "مشكلة في الإطار", icon: "🖼️" },
  { key: "printing", label: "مشكلة في الطباعة", icon: "🖨️" },
  { key: "drawing", label: "مشكلة في الرسم", icon: "🎨" },
  { key: "designer", label: "مشكلة في المصمم", icon: "📐" },
  { key: "transport", label: "مشكلة في شركة النقل", icon: "🚚" },
  { key: "employee", label: "مشكلة في الموظف المصمم", icon: "👤" },
];

const rejectedOrders = [...orders, ...archivedOrders].filter((o) =>
  // 1) الملغيات اللي بعدهم ب orders
  o.status?.startsWith("ملغي") ||

  // 2) المؤرشفة بسبب رفض الزبون (حسب الحقول اللي نخزنها بالأرشيف)
  o.rejectionType === "late_delivery" ||
  o.archiveReason === "late_delivery_rejected"
);

const internalRejected = rejectedOrders.filter(
  o => o.status === "ملغي - تأخير داخلي"
);



const lateRejected = rejectedOrders.filter(
  (o) =>
    o.status === "ملغي - وصل متأخر ورفضه الزبون" ||
    o.rejectionType === "late_delivery" ||
    o.archiveReason === "late_delivery_rejected"
);


const damagedRejected = rejectedOrders.filter(
  o => o.status === "ملغي - متضررة"
);


// القيم: الكل | بيع | حساب نرسي | حساب استاذ مروان | ماركتنك
const [yearStatOwner, setYearStatOwner] = useState(null); 
const [delayDialogOpen, setDelayDialogOpen] = useState(false);
const buildNegativeIssuesDetails = (orders) => {
  const rows = [];

  orders.forEach((order) => {
    if (order.feedback?.type !== "سلبي") return;

    const note = order.feedback?.note || "";
    const employee = order.employee || "غير محدد";

    const issuesMap = [
      { label: "مشكلة في الإطار", source: "الإطار" },
      { label: "مشكلة في الطباعة", source: "الطباعة" },
      { label: "مشكلة في الرسم", source: "الرسم" },
      { label: "مشكلة في المصمم", source: "المصمم" },
      { label: "مشكلة في شركة النقل", source: "شركة النقل" },
      { label: "مشكلة في الموظف المصمم", source: "الموظف" },
    ];

    issuesMap.forEach((issue) => {
      if (note.includes(issue.label)) {
        rows.push({
          orderId: order.id,
          customerName: order.customerName,
          employee,
          issue: issue.label,
          source: issue.source,
            price: Number(order.price) || 0, // ✅ أضف السعر

        });
      }
    });
  });

  return rows;
};

// القيم: الكل | مدفوع | غير مدفوع
const [previewFile, setPreviewFile] = useState(null);
const [yearFilter, setYearFilter] = useState(2026);
const [yearStatFilter, setYearStatFilter] = useState("all"); 
// all | done | inProgress

const [selectedSource, setSelectedSource]= useState([]);
const [taskDialogOpen, setTaskDialogOpen] = useState(false);
const [taskText, setTaskText] = useState("");
const [taskEmployee, setTaskEmployee] = useState("");
const [taskFiles, setTaskFiles] = useState([]);
const [taskImages, setTaskImages] = useState([]);
const [uploading, setUploading] = useState(false);
const paymentMethodLabel = {
  full_online: "دفع كامل أونلاين",
  full_cash: "دفعة كاملة كاش",
  deposit: "دفعة أولية",
    deposit_cash: "دفعة أولية كاش",
  cash_on_delivery: "دفع عند الاستلام",
};

const analyzeNegativeFeedback = (orders) => {
  const result = {};

  // تهيئة
  NEGATIVE_ISSUE_TYPES.forEach((t) => {
    result[t.key] = {
      label: t.label,
      icon: t.icon,
      count: 0,
      orders: [], // نخزن IDs
    };
  });

  orders.forEach((order) => {
    if (order.feedback?.type !== "سلبي") return;
    const note = order.feedback?.note || "";

    NEGATIVE_ISSUE_TYPES.forEach((t) => {
      if (note.includes(t.label)) {
        result[t.key].count += 1;
        result[t.key].orders.push(order.id);
      }
    });
  });

  return result;
};

// ✅ 1) تحويل Timestamp إلى Date safely
const toDateSafe = (ts) => {
  try {
    if (!ts) return null;
    if (typeof ts.toDate === "function") return ts.toDate();
    // لو timestamp مخزن بشكل مختلف
    if (ts.seconds) return new Date(ts.seconds * 1000);
    return null;
  } catch {
    return null;
  }
};

// ✅ 2) تحديد منو المسؤول عن الحالة
const resolveOwner = (order, status, by) => {
  if (!status) return by || null;

  // المصمم
  if (status === "عند يوسف") return "المصمم";

  // الورشة (كل حالات عند برهان حتى الرسم وغيرها)
  if (status.startsWith("عند برهان")) {
    // إذا رسم (حليمة أو محمد) - كلاهما الرسام
    if (status.includes("حليمة")) return "الرسام";
    if (status.includes("محمد")) return "الرسام";
    return "الورشة";
  }

  // إعادة للموظفة (أو رجوع)
  if (status.includes("اعادة") || status.includes("إعادة")) {
    return order.employee || by || null;
  }

  // fallback
  return by || null;
};

// ✅ 3) حساب مدة كل شخص داخل طلب واحد (بالدقائق)
const calcOrderDurationsByOwner = (order) => {
  const history = Array.isArray(order.history) ? [...order.history] : [];

  // إذا ماكو تاريخ كافي
  if (history.length < 2) return {};

  // ترتيب حسب الوقت
  history.sort((a, b) => {
    const da = toDateSafe(a.timestamp);
    const db = toDateSafe(b.timestamp);
    return (da?.getTime() || 0) - (db?.getTime() || 0);
  });

  const durations = {}; // { "المصمم": minutes, "الورشة": minutes, ... }

  for (let i = 0; i < history.length - 1; i++) {
    const cur = history[i];
    const next = history[i + 1];

    const curTime = toDateSafe(cur.timestamp);
    const nextTime = toDateSafe(next.timestamp);
    if (!curTime || !nextTime) continue;

    const diffMin = Math.max(0, Math.round((nextTime - curTime) / 60000));
    if (diffMin === 0) continue;
if (
  cur.status?.includes("رسم") &&
  !cur.status?.includes("محمد")
) {
  continue;
}
    const owner = resolveOwner(order, cur.status, cur.by);
    if (!owner) continue;

    durations[owner] = (durations[owner] || 0) + diffMin;
  }

  return durations;
};

// ✅ 4) تجميع على كل الطلبات (يعطيك: مجموع دقائق + عدد الطلبات اللي مرّت على الشخص + المتوسط)
const buildOwnersPerformance = (orders) => {
  const acc = {}; 
  // acc[owner] = { totalMinutes, ordersTouched: Set, eventsCount }

  for (const order of orders) {
    const d = calcOrderDurationsByOwner(order);

    Object.entries(d).forEach(([owner, minutes]) => {
      if (!acc[owner]) {
        acc[owner] = {
          totalMinutes: 0,
          ordersTouched: new Set(),
        };
      }
      acc[owner].totalMinutes += minutes;
      acc[owner].ordersTouched.add(order.id);
    });
  }

  // تحويل للعرض
  const result = Object.entries(acc).map(([owner, v]) => {
    const countOrders = v.ordersTouched.size;
    const avg = countOrders ? Math.round(v.totalMinutes / countOrders) : 0;
    return {
      owner,
      totalMinutes: v.totalMinutes,
      ordersCount: countOrders,
      avgMinutesPerOrder: avg,
    };
  });

  // ترتيب الأكثر تأخيراً
  result.sort((a, b) => b.avgMinutesPerOrder - a.avgMinutesPerOrder);

  return result;
};



const formatMinutesToDays = (minutes) => {
  const total = Number(minutes || 0);

  const days = Math.floor(total / (60 * 24));
  const hours = Math.floor((total % (60 * 24)) / 60);
  const mins = total % 60;

  let text = "";
  if (days > 0) text += `${days} يوم `;
  if (hours > 0) text += `${hours} ساعة `;
  if (mins > 0) text += `${mins} دقيقة`;

  return text.trim() || "0 دقيقة";
};

const DONE_STATUSES = ["تم التوصيل", "تم التركيب", "تركيب", "تم التوصيل (بعد الفيدباك)"];

const getCompletionDate = (order) => {
  const history = Array.isArray(order.history) ? order.history : [];
  if (!history.length) return null;

  // نرتب تصاعدي
  const sorted = [...history].sort(
    (a, b) => (a.timestamp?.toMillis?.() || 0) - (b.timestamp?.toMillis?.() || 0)
  );

  // نبحث من الأخير للأول عن حالة مكتملة
  for (let i = sorted.length - 1; i >= 0; i--) {
    const st = sorted[i]?.status || "";
    if (DONE_STATUSES.includes(st)) {
      return toDateSafe(sorted[i]?.timestamp);
    }
  }

  // إذا الحالة الحالية مكتملة بس ما نلكاها بالتاريخ (احتياط)
  if (DONE_STATUSES.includes(order.status)) {
    // إذا عندك حقل جاهز مثل deliveredAt استخدمه هنا
    return toDateSafe(order.updatedAt) || null;
  }

  return null;
};

const getOrderTotalDurationMinutes = (order) => {
  const start = order.createdAt?.toDate?.();
  if (!start) return null;

  const end = getPackagingDate(order);

  if (!end) return null;

  const diff = Math.floor((end.getTime() - start.getTime()) / 60000);

  return diff > 0 ? diff : 0;
};
const formatDurationDaysOnly = (minutes) => {
  const total = Number(minutes || 0);
  const days = total / (60 * 24);

  if (days < 1) {
    return "أقل من يوم";
  }

  const rounded = Math.round(days * 10) / 10; // نص يوم مثل 1.5
  return `${rounded} يوم`;
};


const filteredDelayOrders = orders.filter(o => {
  const d = o.createdAt?.toDate?.();
  if (!d) return false;

  if (fromDate) {
    const from = new Date(fromDate);
    from.setHours(0,0,0,0);
    if (d < from) return false;
  }

  if (toDate) {
    const to = new Date(toDate);
    to.setHours(23,59,59,999);
    if (d > to) return false;
  }

  return true;
});
const performance = buildOwnersPerformance(filteredDelayOrders)
  .filter(p =>
    ["المصمم", "الورشة", "الرسام"].includes(p.owner)
  );
  console.log(performance);



// ✅ الطلبات المكتملة فقط
const completedOrders = orders.filter((o) =>
  ["تم التوصيل", "تركيب", "تم التركيب", "تم التوصيل (بعد الفيدباك)"].includes(o.status)
);

// ✅ حساب مدد الطلبات المكتملة
const completedDurations = completedOrders .map((o) => ({
    id: o.id,
    name: o.customerName,
    minutes: getOrderTotalDurationMinutes(o),
  }))
  .filter((o) => o.minutes !== null);

// ✅ المعدل العام
const avgOrderDuration =
  completedDurations.length > 0
    ? Math.round(
        completedDurations.reduce((s, o) => s + o.minutes, 0) /
          completedDurations.length
      )
    : 0;

// ✅ أسرع وأطول طلب
const fastestOrders = [...completedDurations]
  .sort((a, b) => a.minutes - b.minutes)
  .slice(0, 3);

const slowestOrders = [...completedDurations]
  .sort((a, b) => b.minutes - a.minutes)
  .slice(0, 3);


// 🔢 عدد أيام الشهر الحقيقي
const getDaysInMonth = (year, month) => {
  return new Date(year, month, 0).getDate(); // month: 1-12
};

// 📊 حساب معدل الطلبات باليوم
const getDailyAverage = (monthKey, count) => {
  if (!count) return 0;

  const [year, month] = monthKey.split("-").map(Number);
  const now = new Date();

  const isCurrentMonth =
    now.getFullYear() === year && now.getMonth() + 1 === month;

  // إذا الشهر الحالي نحسب لليوم الحالي، غيره نحسب كامل الشهر
  const days = isCurrentMonth
    ? now.getDate()
    : getDaysInMonth(year, month);

  return Math.round(count / days); // ✅ بدون فاصلة
};


const isPaymentVisible = (order) => {
  if (!order.deliveryPaid) return false;

  if (!order.deliveryPaidVisibleAt) return true; 
  // احتياط للطلبات القديمة

  const visibleAt = order.deliveryPaidVisibleAt?.toDate?.();
  if (!visibleAt) return true;

  return visibleAt <= new Date();
};

// 📦 طلبات ثابتة للأشهر 5 / 6 / 7 (للإكسل فقط)
const staticExcelOrders = [
  // ===== 2025-01 =====
  {
    customerName: "طلبات أرشيفية",
    price: 695000,
    governorate: "—",
    status: "تم التوصيل",
    employee: "—",
    source: "أرشيف",
    orderType: "Sales",
    createdAt: "2025-01",
    note: "طلبات ثابتة",
  },

  // ===== 2025-02 =====
  {
    customerName: "طلبات أرشيفية",
    price: 2060000,
    governorate: "—",
    status: "تم التوصيل",
    employee: "—",
    source: "أرشيف",
    orderType: "Sales",
    createdAt: "2025-02",
    note: "طلبات ثابتة",
  },

  // ===== 2025-03 =====
  {
    customerName: "طلبات أرشيفية",
    price: 3275000,
    governorate: "—",
    status: "تم التوصيل",
    employee: "—",
    source: "أرشيف",
    orderType: "Sales",
    createdAt: "2025-03",
    note: "طلبات ثابتة",
  },

  // ===== 2025-04 =====
  {
    customerName: "طلبات أرشيفية",
    price: 2050000,
    governorate: "—",
    status: "تم التوصيل",
    employee: "—",
    source: "أرشيف",
    orderType: "Sales",
    createdAt: "2025-04",
    note: "طلبات ثابتة",
  },
  // ===== 2025-05 =====
  {
    customerName: "طلبات أرشيفية - Sales",
    price: 450000,
    governorate: "—",
    status: "تم التوصيل",
    employee: "—",
    source: "أرشيف",
    orderType: "Sales",
    createdAt: "2025-05",
    note: "طلبات ثابتة",
  },
  {
    customerName: "طلبات أرشيفية - Marketing",
    price: 2894000,
    governorate: "—",
    status: "تم التوصيل",
    employee: "—",
    source: "أرشيف",
    orderType: "Marketing",
    createdAt: "2025-05",
    note: "طلبات ثابتة",
  },

  // ===== 2025-06 =====
  {
    customerName: "طلبات أرشيفية - Sales",
    price: 4425000,
    governorate: "—",
    status: "تم التوصيل",
    employee: "—",
    source: "أرشيف",
    orderType: "Sales",
    createdAt: "2025-06",
    note: "طلبات ثابتة",
  },
  {
    customerName: "طلبات أرشيفية - Marketing",
    price: 7307000,
    governorate: "—",
    status: "تم التوصيل",
    employee: "—",
    source: "أرشيف",
    orderType: "Marketing",
    createdAt: "2025-06",
    note: "طلبات ثابتة",
  },

  // ===== 2025-07 =====
  {
    customerName: "طلبات أرشيفية - Sales",
    price: 5464000,
    governorate: "—",
    status: "تم التوصيل",
    employee: "—",
    source: "أرشيف",
    orderType: "Sales",
    createdAt: "2025-07",
    note: "طلبات ثابتة",
  },
  {
    customerName: "طلبات أرشيفية - Marketing",
    price: 3563000,
    governorate: "—",
    status: "تم التوصيل",
    employee: "—",
    source: "أرشيف",
    orderType: "Marketing",
    createdAt: "2025-07",
    note: "طلبات ثابتة",
  },
];
// ✅ حالات تعتبر "اكتمال" حسب نظامك

// ✅ يرجع تاريخ الاكتمال من history (آخر مرة وصل لمرحلة مكتملة)

// ✅ يحسب عدد الأيام بين تاريخين
const diffDays = (startDate, endDate) => {
  if (!startDate || !endDate) return "";
  const ms = endDate.getTime() - startDate.getTime();
  const days = Math.ceil(ms / (1000 * 60 * 60 * 24));
  return days > 0 ? days : 0;
};

// ✅ تنسيق تاريخ عربي
const formatDateAR = (d) => (d ? d.toLocaleString("ar-IQ") : "");

const exportToExcel = () => {
  let exportOrders = [...orders];

  // فلترة بالتاريخ (للطلبات الحقيقية فقط)
  if (fromDate && toDate) {
    const from = new Date(fromDate);
    const to = new Date(toDate);
    to.setHours(23, 59, 59, 999);

    exportOrders = exportOrders.filter((order) => {
      const createdAt = order.createdAt?.toDate?.();
      return createdAt && createdAt >= from && createdAt <= to;
    });
  }

  // 🔥 دمج الطلبات الحقيقية + الطلبات الثابتة
  const mergedOrders = [...exportOrders, ...staticExcelOrders];

  if (mergedOrders.length === 0) {
    alert("لا توجد طلبات للتصدير");
    return;
  }

  const data = mergedOrders.map((order, index) => ({
    "تسلسل": index + 1,
    "اسم الزبون": order.customerName || "",
    "المبلغ": Number(order.price || 0),
    "المحافظة": order.governorate || "",
    "الحالة":
      (order.completedSteps?.length
        ? getDisplayStatus(
            `عند برهان - ${order.completedSteps[order.completedSteps.length - 1]}`
          )
        : getDisplayStatus(order.status, order)) || "",
    "الموظف": order.employee || "",
    "مصدر الطلب": order.source || "",
    "نوع الزبون": orderTypeLabels[order.orderType] || order.orderType || "",
    "تاريخ الطلب":
      typeof order.createdAt === "string"
        ? order.createdAt
        : order.createdAt?.toDate
        ? order.createdAt.toDate().toLocaleDateString("ar-IQ")
        : "",
    "ملاحظات": order.note || "",
  }));

  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "الطلبات");

  XLSX.writeFile(workbook, "طلبات_ارتيكا_كاملة.xlsx");
};
  useEffect(() => {
    fetchOrders();
  }, []);

 const fetchOrders = async () => {
  // 1) orders
  const querySnapshot = await getDocs(collection(db, "orders"));
  const data = querySnapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));

  const sorted = data.sort((a, b) => {
    const aTime = a.createdAt?.toMillis?.() || 0;
    const bTime = b.createdAt?.toMillis?.() || 0;
    return bTime - aTime;
  });

  setOrders(sorted);
  setFilteredOrders(sorted);

  // 2) archivedOrders ✅
  const archivedSnap = await getDocs(collection(db, "archivedOrders"));
  const archivedData = archivedSnap.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));

  // ترتيب اختياري للأرشيف
  const archivedSorted = archivedData.sort((a, b) => {
    const aTime = a.archivedAt?.toMillis?.() || a.createdAt?.toMillis?.() || 0;
    const bTime = b.archivedAt?.toMillis?.() || b.createdAt?.toMillis?.() || 0;
    return bTime - aTime;
  });

  setArchivedOrders(archivedSorted);
};
const matchFilter = (value, filterArray) => {
  if (!filterArray || filterArray.length === 0) return true;
  return filterArray.includes(value);
};

  useEffect(() => {
    let result = [...orders];
        result = result.filter(order => !order.excludedFromStats);

// ✅ افتراضيًا: استبعد طلبات الماركتنك من كل الفلاتر العامة
// إلا إذا المستخدم اختار "ماركتنك" صراحة
if (saleAccountFilter !== "ماركتنك") {
  result = result.filter((order) => (order.saleAccount || "بيع") !== "ماركتنك");
}

 result = result.filter((order) =>
  matchFilter(order.employee, selectedEmployee)
);
if (selectedStatus.length > 0) {
  result = result.filter((order) => {
    const status = order.status || "";
    const lastStep =
      order.completedSteps?.[order.completedSteps.length - 1] || "";

return selectedStatus.some((selected) => {
        switch (selected) {
        case "عند المصمم":
          return status === "عند يوسف";

        case "عند الورشة":
          return status.startsWith("عند برهان");

        case "طباعة":
          return status.startsWith("عند برهان") && lastStep === "طباعة";

        case "اطار":
          return (
            status.startsWith("عند برهان") &&
            (lastStep === "إطار" || lastStep === "اطار")
          );

        case "رسم":
          return status.startsWith("عند برهان") && lastStep === "رسم";

        case "تغليف":
          return status.startsWith("عند برهان") && lastStep === "تغليف";

        case "🚀 رسم - بدأ":
          return status.includes("رسم") && status.includes("بدأ");

        case "✅ رسم - مكتمل":
          return status.includes("رسم") && status.includes("مكتمل");

        case "تم التوصيل":
          return ["تم التوصيل", "تم التوصيل (بعد الفيدباك)"].includes(status);

        case "تم التركيب":
          return ["تم التركيب", "تركيب"].includes(status);

        case " 📩 تم التوصيل_فيدباك  ":
          return status === "feedbackRequired";

        default:
          return false;
      }
    });
  });
}



 result = result.filter((order) =>
  matchFilter(order.governorate, selectedGovernorate)
);
 result = result.filter((order) =>
  matchFilter(order.source, selectedSource)
);
// ✅ فلترة حسب حساب البيع (بوكسات المدير)
if (saleAccountFilter !== "الكل") {
  result = result.filter((order) => (order.saleAccount || "بيع") === saleAccountFilter);
}
// ✅ فلترة حسب بوكسات السنة (2025/2026)
// ✅ فلترة حسب السنة (2025 / 2026)
// ✅ فلترة السنة تعمل فقط إذا لا يوجد بحث باسم الزبون
if (yearFilter !== "الكل" && searchTerm.trim() === "") {
  result = result.filter((order) => {
    const d = order.createdAt?.toDate?.();
    if (!d) return false;
    return d.getFullYear() === yearFilter;
  });
}

// ✅ فلترة بوكسات السنة (تشتغل فقط إذا المالك هو نفس السنة المختارة)
if (yearFilter !== "الكل" && yearStatOwner === yearFilter) {
  if (yearStatFilter === "done") {
    result = result.filter((order) =>
      DONE_STATUSES.includes(order.status)
    );
  } else if (yearStatFilter === "inProgress") {
    result = result.filter((order) =>
      !DONE_STATUSES.includes(order.status)
    );
  }
}



  if (searchTerm.trim() !== "") {
  result = result.filter((order) =>
    (order.customerName || "")
      .toLowerCase()
      .includes(searchTerm.trim().toLowerCase())
  );
}
if (paymentFilter.length > 0) {

result = result.filter(order => {

return paymentFilter.some(filter => {

if(filter === "مدفوع") return isPaymentVisible(order)

if(filter === "غير مدفوع") return !isPaymentVisible(order)

return false

})

})

}
// ✅ فلترة حسب طريقة الدفع
result = result.filter((order) =>
  matchFilter(order.payment?.method, paymentMethodFilter)
);

    if (fromDate && toDate) {
      const from = new Date(fromDate);
      const to = new Date(toDate);
      result = result.filter((order) => {
        const createdAt = order.createdAt?.toDate?.();
        return createdAt >= from && createdAt <= to;
      });
    }
    // ✅ فلترة حسب السنة (2025 / 2026)
// ✅ فلترة السنة تعمل فقط إذا لا يوجد بحث باسم الزبون
if (yearFilter !== "الكل" && searchTerm.trim() === "") {
  result = result.filter((order) => {
    const d = order.createdAt?.toDate?.();
    if (!d) return false;
    return d.getFullYear() === yearFilter;
  });
}

    if (selectedMonth) {
      result = result.filter((order) => {
        const date = order.createdAt?.toDate?.();
        if (!date) return false;
        const key = `${date.getFullYear()}-${String(
          date.getMonth() + 1
        ).padStart(2, "0")}`;
        return key === selectedMonth;
      });
    }

    // فلترة حسب الزر المضغوط (الإحصائيات)
if (activeStatFilter === "done") {
  result = result.filter((order) =>
    ["تم التوصيل", "تركيب", "تم التركيب", "تم التوصيل (بعد الفيدباك)"].includes(order.status)
  );
} else if (activeStatFilter === "positive") {
  result = result.filter((order) => order.feedback?.type === "ايجابي");
} else if (activeStatFilter === "negative") {
  result = result.filter((order) => order.feedback?.type === "سلبي");
}
else if (activeStatFilter === "inProgress") {
  result = result.filter(
    (order) => !["تم التوصيل", "تركيب", "تم التركيب", "تم التوصيل (بعد الفيدباك)"].includes(order.status)
  );
}
else if (activeStatFilter === "all") {
  // لا تفعل شيء، لأن النتيجة الكلية محفوظة مسبقًا
}

if (selectedOrderType.length > 0) {
  result = result.filter((order) => {
    const orderType = order.orderType || "";

    // تطابق مباشر (للقيم الجديدة)
    if (orderType === selectedOrderType) return true;

    // خريطة القيم العربية القديمة
    const reverseMap = {
      "مشروع - فندق": "project_hotel",
      "مشروع - مطعم": "project_restaurant",
      "مشروع - كافيه": "project_cafe",
      "مشروع - صالون": "project_salon",
      "مشروع - عيادة": "project_clinic",
      "مهندس أو مصمم": "engineer_designer",
      "شركة هندسية أو شركة تصميم داخلي": "engineering_company",
      "شقة": "apartment",
      "بيت": "house",
      "انفلونسر / بلوكر / مشهور": "influencer",
      "شركة اثاث": "furniture_company"
    };

    // 🟢 شركات أخرى (باسم متغير)
    if (selectedOrderType === "other_company") {
      return orderType.startsWith("شركات أخرى");
    }

    // باقي الأنواع القديمة
    return reverseMap[orderType] === selectedOrderType;
  });
}



    setFilteredOrders(result);
  }, [
    selectedEmployee,
    selectedStatus,
    selectedGovernorate,
    searchTerm,
    fromDate,
      selectedSource,
    toDate,
    selectedMonth,
    activeStatFilter,
    selectedOrderType,
    orders,
      paymentFilter, // ✅ هذا هو الحل
      paymentMethodFilter,
   saleAccountFilter,
     yearFilter, // ✅ مهم جداً
yearStatFilter,
yearStatOwner,

  ]);

  const uniqueEmployees = ["الكل", "رند", "جمانا", "ساره","بنين",  "المصمم", "الورشة" ];
const fixedStatuses = [
  "الكل",
  "عند المصمم",
  "عند الورشة",
  "طباعة",
  "اطار",
  "رسم",
  "🚀 رسم - بدأ",
  "✅ رسم - مكتمل",
  "تغليف",
  "تم التوصيل",
  "تم التركيب",
  "   📩 تم التوصيل_فيدباك",
];






  const uniqueGovernorates = [
    "الكل",
    ...new Set(orders.map((o) => o.governorate).filter(Boolean)),
  ];
const uniqueSources = [
  "الكل",
  ...new Set(orders.map((o) => o.source).filter(Boolean)),
];
const uniqueOrderTypes = [
  "الكل",
  "project_hotel",
  "project_restaurant",
  "project_cafe",
  "project_salon",
  "project_clinic",
  "project_beauty_center",
"project_hospital",
  "engineer_designer",
  "engineering_company",
  "other_company",
  "apartment",
  "house",
    // ✅ الجدد
  "influencer",
  "furniture_company",
];


 // مجموع السعر للطلبات بعد الفلترة (حسب الفلاتر العامة مثل الموظف، المحافظة، التاريخ)
const totalPrice = filteredOrders.reduce(
  (sum, order) => sum + (parseFloat(order.price) || 0),
  0
);
// 💰 تحليل الدفع حسب الفلاتر الحالية
const onlinePayments = filteredOrders.filter(
  (o) =>
    o.payment?.method === "full_online" ||
    o.payment?.method === "deposit"
);

const totalOnlineAmount = onlinePayments.reduce(
  (sum, o) =>
    sum +
    (o.payment?.method === "deposit"
      ? Number(o.payment?.depositAmount || 0)
      : Number(o.price || 0)),
  0
);

// تفصيل حسب الوسيلة
const qiTotal = onlinePayments
  .filter((o) => o.payment?.provider === "Qi Card")
  .reduce(
    (sum, o) =>
      sum +
      (o.payment?.method === "deposit"
        ? Number(o.payment?.depositAmount || 0)
        : Number(o.price || 0)),
    0
  );

const zainTotal = onlinePayments
  .filter((o) => o.payment?.provider === "Zain Cash")
  .reduce(
    (sum, o) =>
      sum +
      (o.payment?.method === "deposit"
        ? Number(o.payment?.depositAmount || 0)
        : Number(o.price || 0)),
    0
  );

const fibTotal = onlinePayments
  .filter((o) => o.payment?.provider === "FIB")
  .reduce(
    (sum, o) =>
      sum +
      (o.payment?.method === "deposit"
        ? Number(o.payment?.depositAmount || 0)
        : Number(o.price || 0)),
    0
  );
  const showPaymentAnalysis =
  paymentMethodFilter.includes("deposit") ||
  paymentMethodFilter.includes("full_online");



// ✅ بعد (يحسب من الطلبات المفلترة)
const positiveCount = filteredOrders.filter((o) => o.feedback?.type === "ايجابي").length;
const negativeCount = filteredOrders.filter((o) => o.feedback?.type === "سلبي").length;
// ✅ عدد الطلبات الفريدة التي تحتوي مشاكل (فيدباك سلبي)


const monthlyBreakdown = {};
orders.forEach((order) => {
  const date = order.createdAt?.toDate?.();
  if (!date) return;

  const key = `${date.getFullYear()}-${String(
    date.getMonth() + 1
  ).padStart(2, "0")}`;


  if (!monthlyBreakdown[key]) {
    monthlyBreakdown[key] = {
      count: 0,
      total: 0,
      paid: 0,
      remaining: 0,
        // 🆕 ماركتنك
    marketingCount: 0,
    marketingTotal: 0,

      // 🆕 الرسم
       totalBoardsCount: 0,  
      drawingOrdersCount: 0,
      drawingBoardsCount: 0,
        assemblyOrdersCount: 0, // عدد الطلبات اللي بيها تركيب
         // 🆕 أضف هذا
    negativeCount: 0,
    negativeTotal: 0,
    };
  }
// ✅ 2) بعدها استعمله بدون خوف
  monthlyBreakdown[key].totalBoardsCount += Number(
    order.boardsCount || 0
  );

  const price = Number(order.price) || 0;
// 👎 حساب الطلبات المرفوضة داخل الشهر
if (order.feedback?.type === "سلبي") {
  monthlyBreakdown[key].negativeCount += 1;
  monthlyBreakdown[key].negativeTotal += price;
}

  monthlyBreakdown[key].count += 1;
// 📣 إذا ماركتنك → لا يدخل بالمجموع الكلي
if ((order.saleAccount || "بيع") === "ماركتنك") {
  monthlyBreakdown[key].marketingCount += 1;
  monthlyBreakdown[key].marketingTotal += price;
} else {
  // ✅ فقط غير الماركتنك يدخل بالمجموع
  monthlyBreakdown[key].total += price;
}

if ((order.saleAccount || "بيع") !== "ماركتنك") {
  if (isPaymentVisible(order)) {
    monthlyBreakdown[key].paid += price;
  } else {
    monthlyBreakdown[key].remaining += price;
  }
}

  // 🎨 حساب الرسم
  if (order.withDrawing === true) {
    monthlyBreakdown[key].drawingOrdersCount += 1;
    monthlyBreakdown[key].drawingBoardsCount += Number(
      order.drawingBoardsCount || 0
    );
  }
  // 🛠️ التركيب
if (order.withAssembly === true) {
  monthlyBreakdown[key].assemblyOrdersCount += 1;
}
});


// البيانات الثابتة للطلبات القديمة حسب كل شهر
const staticOldMonths = {
   // 🔹 Jan 2025
  "2025-01": {
    salesCount: 2,
    salesTotal: 695000,
    marketingCount: 0,
    marketingTotal: 0,
  },

  // 🔹 Feb 2025
  "2025-02": {
    salesCount: 10,
    salesTotal: 2060000,
    marketingCount: 0,
    marketingTotal: 0,
  },

  // 🔹 Mar 2025
  "2025-03": {
    salesCount: 12,
    salesTotal: 3275000,
    marketingCount: 0,
    marketingTotal: 0,
  },

  // 🔹 Apr 2025
  "2025-04": {
    salesCount: 12,
    salesTotal: 2050000,
    marketingCount: 0,
    marketingTotal: 0,
  },
  "2025-05": {
    salesCount: 2,
    salesTotal: 450000,
    marketingCount: 11,
    marketingTotal: 2894000,
  },
  "2025-06": {
    salesCount: 4,
    salesTotal: 4425000,
    marketingCount: 23,
    marketingTotal: 7307000,
  },
  "2025-07": {
    salesCount: 5,
    salesTotal: 5464000,
    marketingCount: 13,
    marketingTotal: 3563000,
  },
};
// 📌 اجمالي الطلبات (من الفلاتر فقط - Firebase)
const totalOrdersCount = filteredOrders.length;
const totalOrdersAmount = filteredOrders.reduce(
  (sum, order) => sum + (parseFloat(order.price) || 0),
  0
);

// ✅ اجمالي المكتمل (من الفلاتر فقط - Firebase)
const deliveredOrders = filteredOrders.filter((order) =>
  ["تم التوصيل", "تركيب", "تم التركيب", "تم التوصيل (بعد الفيدباك)"].includes(order.status)
);

const totalDelivered = deliveredOrders.length;
const deliveredAmount = deliveredOrders.reduce(
  (sum, o) => sum + (parseFloat(o.price) || 0),
  0
);

// ✅ اجمالي قيد العمل (من الفلاتر فقط - Firebase)
const inProgressOrders = filteredOrders.filter(
  (order) =>
    !["تم التوصيل", "تركيب", "تم التركيب", "تم التوصيل (بعد الفيدباك)"].includes(order.status)
);
const negativeIssuesDetails = buildNegativeIssuesDetails(filteredOrders);

const totalInProgress = inProgressOrders.length;
const priceInProgress = inProgressOrders.reduce(
  (sum, o) => sum + (parseFloat(o.price) || 0),
  0
);

// 📌 اجمالي الطلبات القديمة الثابتة (5،6،7) — كلها مكتملة
const staticTotals = Object.values(staticOldMonths).reduce(
  (acc, m) => {
    acc.count += (m.salesCount || 0) + (m.marketingCount || 0);
    acc.total += (m.salesTotal || 0) + (m.marketingTotal || 0);
    return acc;
  },
  { count: 0, total: 0 }
);
// ✅ دمج الأشهر الثابتة داخل سنة 2025 فقط


// ✅ قرار: إذا المستخدم مختار "الكل" بدون أي فلاتر → نجمع مع الثابتة
const isAllFilter =
  selectedEmployee === "الكل" &&
  selectedGovernorate === "الكل" &&
  selectedSource === "الكل" &&
  !fromDate &&
  !toDate &&
  !selectedMonth;

// 📌 المجموع النهائي
const grandTotalCount = isAllFilter ? totalOrdersCount + staticTotals.count : totalOrdersCount;
const grandTotalAmount = isAllFilter ? totalOrdersAmount + staticTotals.total : totalOrdersAmount;

// 📌 المجموع النهائي للمكتمل
const grandDeliveredCount = isAllFilter ? totalDelivered + staticTotals.count : totalDelivered;
const grandDeliveredAmount = isAllFilter ? deliveredAmount + staticTotals.total : deliveredAmount;

// دمج الطلبات القديمة مع البيانات الحقيقية لكل شهر
const monthlyBreakdownWithStatic = {
  ...monthlyBreakdown,
};

const getOrderYear = (order) => {
  const d = order.createdAt?.toDate?.();
  if (!d) return null;
  return d.getFullYear();
};

for (const [month, data] of Object.entries(staticOldMonths)) {
  if (!monthlyBreakdownWithStatic[month]) {
    monthlyBreakdownWithStatic[month] = {
      count: data.salesCount + data.marketingCount,
      total: data.salesTotal + data.marketingTotal,
      isStatic: true,
      staticDetails: data,
    };
  }
}
const buildYearStats = (year, sourceOrders) => {
  const yearOrders = sourceOrders.filter(
    (o) =>
          !o.excludedFromStats &&   // ✅ أضف هذا
      getOrderYear(o) === year &&
      (o.saleAccount || "بيع") !== "ماركتنك"
  );
  const totalCount = yearOrders.length;
  const totalAmount = yearOrders.reduce((s, o) => s + (Number(o.price) || 0), 0);

  const doneOrders = yearOrders.filter((o) =>
    ["تم التوصيل", "تركيب", "تم التركيب", "تم التوصيل (بعد الفيدباك)"].includes(o.status)
  );
  const doneCount = doneOrders.length;
  const doneAmount = doneOrders.reduce((s, o) => s + (Number(o.price) || 0), 0);

  const inProgressOrders = yearOrders.filter(
    (o) =>
      !["تم التوصيل", "تركيب", "تم التركيب", "تم التوصيل (بعد الفيدباك)"].includes(o.status)
  );
  const inProgressCount = inProgressOrders.length;
  const inProgressAmount = inProgressOrders.reduce(
    (s, o) => s + (Number(o.price) || 0),
    0
  );

  const positive = yearOrders.filter((o) => o.feedback?.type === "ايجابي").length;
  const negative = yearOrders.filter((o) => o.feedback?.type === "سلبي").length;

  // 🧩 عدد اللوحات
  const boardsCount = yearOrders.reduce(
    (acc, o) => acc + Number(o.boardsCount || 0),
    0
  );

  // 🎨 عدد الطلبات اللي بيها رسم
  const drawingOrdersCount = yearOrders.filter((o) => o.withDrawing === true).length;

  // 🖌️ عدد لوحات الرسم
  const drawingBoardsCount = yearOrders.reduce(
    (acc, o) => acc + Number(o.drawingBoardsCount || 0),
    0
  );

  return {
    totalCount,
    totalAmount,
    doneCount,
    doneAmount,
    inProgressCount,
    inProgressAmount,
    positive,
    negative,
    boardsCount,
    drawingOrdersCount,
    drawingBoardsCount,
  };
};

const stats2025 = buildYearStats(2025, orders);
const stats2026 = buildYearStats(2026, orders);
const shouldAddStatic = yearFilter === "الكل" || yearFilter === 2025;

// ✅ دمج الأشهر الثابتة داخل سنة 2025 فقط
const stats2025WithStatic = {
  ...stats2025,

  totalCount: stats2025.totalCount + staticTotals.count,
  totalAmount: stats2025.totalAmount+ (shouldAddStatic ? staticTotals.total : 0),

  doneCount: stats2025.doneCount + staticTotals.count,
  doneAmount: stats2025.doneAmount + (shouldAddStatic ? staticTotals.total : 0),
};

// ✅ مجموع 2025 + 2026 (بدون تغيير أي بروسيس)
const statsAllYears = {
totalCount: filteredOrders.length + (shouldAddStatic ? staticTotals.count : 0),
  totalAmount:
    filteredOrders.reduce((s,o)=>s+(Number(o.price)||0),0) + (shouldAddStatic ? staticTotals.total : 0),

 doneCount:
  filteredOrders.filter(o =>
    ["تم التوصيل","تركيب","تم التركيب","تم التوصيل (بعد الفيدباك)"]
    .includes(o.status)
  ).length + (shouldAddStatic ? staticTotals.count : 0),

doneAmount:
  filteredOrders
    .filter(o =>
      ["تم التوصيل","تركيب","تم التركيب","تم التوصيل (بعد الفيدباك)"]
      .includes(o.status)
    )
    .reduce((s,o)=>s+(Number(o.price)||0),0) + (shouldAddStatic ? staticTotals.total : 0),

  inProgressCount:
    filteredOrders.filter(o =>
      !["تم التوصيل","تركيب","تم التركيب","تم التوصيل (بعد الفيدباك)"]
      .includes(o.status)
    ).length,

  inProgressAmount:
    filteredOrders
      .filter(o =>
        !["تم التوصيل","تركيب","تم التركيب","تم التوصيل (بعد الفيدباك)"]
        .includes(o.status)
      )
      .reduce((s,o)=>s+(Number(o.price)||0),0),

  positive: filteredOrders.filter(o=>o.feedback?.type==="ايجابي").length,
  negative: filteredOrders.filter(o=>o.feedback?.type==="سلبي").length,

  boardsCount: filteredOrders.reduce((s,o)=>s+Number(o.boardsCount||0),0),

  drawingOrdersCount: filteredOrders.filter(o=>o.withDrawing===true).length,

  drawingBoardsCount: filteredOrders.reduce((s,o)=>s+Number(o.drawingBoardsCount||0),0)
};


// ✅ دالة لإعادة تسمية الحالات في واجهة المدير
const renameStatus = (status, order) => {
  if (!status) return "";

  return getDisplayStatus(status, order).replace(
    "feedbackRequired",
    " 📩 تم التوصيل_فيدباك  "
  );
};

const orderTypeLabels = {
  project_hotel: "مشروع - فندق",
  project_restaurant: "مشروع - مطعم",
  project_cafe: "مشروع - كافيه",
  project_salon: "مشروع - صالون",
  project_clinic: "مشروع - عيادة",
project_beauty_center: "مشروع - مركز تجميل",
project_hospital: "مشروع - مستشفى",

  engineer_designer: "مهندس أو مصمم",
  engineering_company: "شركة هندسية أو شركة تصميم داخلي",

  other_company: "شركات أخرى",

  apartment: "شقة",
  house: "بيت",
    // ✅ الجدد
  influencer: "انفلونسر / بلوكر / مشهور",
  furniture_company: "شركة اثاث"
};

const getSaleAccount = (o) => o.saleAccount || "بيع"; // للطلبات القديمة

const salesOnlyOrders = orders.filter((o) => getSaleAccount(o) !== "ماركتنك");
const narcyOrders = orders.filter((o) => getSaleAccount(o) === "حساب نرسي");
const marwanOrders = orders.filter((o) => getSaleAccount(o) === "حساب استاذ مروان");
const sudaSumerOrders = orders.filter((o) => getSaleAccount(o) === "مطبعة صدى سومر - أبو زينب (زبون)");
const marketingOrders = orders.filter((o) => getSaleAccount(o) === "ماركتنك");

const sumPrice = (arr) =>
  arr.reduce((acc, o) => acc + (Number(o.price) || 0), 0);

const totalNarcy = sumPrice(narcyOrders);
const totalMarwan = sumPrice(marwanOrders);
const totalSudaSumer = sumPrice(sudaSumerOrders);
const totalMarketing = sumPrice(marketingOrders);
// ✅ مبيعات Firebase بدون ماركتنك
const totalSalesOnlyFirebase = sumPrice(
  orders.filter((o) => (o.saleAccount || "بيع") !== "ماركتنك")
);

// ✅ مبيعات الأشهر الثابتة بدون ماركتنك (Sales فقط)
const staticSalesTotal = Object.values(staticOldMonths).reduce(
  (acc, m) => acc + (m.salesTotal || 0),
  0
);

// ✅ إذا كل الفلاتر "الكل" → اجمع Firebase + الثابتة
const totalSalesOnly = isAllFilter
  ? totalSalesOnlyFirebase + staticSalesTotal
  : totalSalesOnlyFirebase;
// ✅ ترتيب الأشهر: 2026 فوق (تنازلي) + 2025 تحت (تصاعدي)
const sortedMonthEntries = Object.entries(monthlyBreakdownWithStatic)
  .sort((a, b) => new Date(b[0] + "-01") - new Date(a[0] + "-01"));


  return (
    <Container sx={{ mt: 4 }} dir="rtl">
      <Typography
        variant="h4"
        align="right"
        gutterBottom
        fontWeight={600}
        sx={{ mb: 3 }}
      >
        لوحة المحاسب
      </Typography>
<Box
  sx={{
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px,1fr))",
    gap: 2,
    mb: 4,
  }}
>


  {showBuiltIn("extra:invoiceStats") && (
  <Button
    variant="contained"
      sx={{ ...dashboardBoxStyle, backgroundColor: "#546e7a" }}

    onClick={() => navigate("/invoice-stats")}
  >
    📊 إحصائيات الفواتير
  </Button>
  )}

  {showBuiltIn("extra:workshopExpenses") && (
  <Button
    variant="contained"
    color="secondary"
      sx={{ ...dashboardBoxStyle, backgroundColor: "#3f51b5" }}

    onClick={() => navigate("/burhan-expenses")}
  >
    💵 مصاريف الورشة
  </Button>
  )}


 <Button
    variant="contained"
    color="success"
    onClick={exportToExcel}
       sx={{ ...dashboardBoxStyle, backgroundColor: "#3f51b5" }}

  >
    📥 سحب الطلبات إلى Excel
  </Button>
</Box>
<Grid
  container
  spacing={2}
  sx={{
    mb: 3,
    alignItems: "center",
    background: "#fafafa",
    p: 2,
    borderRadius: 3,
  }}
>   

        <Grid item xs={12} md={3}>
          <TextField
            label="من"
            type="date"
            fullWidth
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            label="إلى"
            type="date"
            fullWidth
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
     
     
       
  


<Grid item xs={12} md={3}>
<FormControl fullWidth>

<InputLabel shrink sx={{ right: 0, left: "auto" }}>
الدفع
</InputLabel>

<Select
multiple
value={paymentFilter}
onChange={(e)=>setPaymentFilter(e.target.value)}
renderValue={(selected)=>selected.join(" ، ")}
>

<MenuItem value="مدفوع">
<Checkbox checked={paymentFilter.indexOf("مدفوع") > -1}/>
<ListItemText primary="مدفوع"/>
</MenuItem>

<MenuItem value="غير مدفوع">
<Checkbox checked={paymentFilter.indexOf("غير مدفوع") > -1}/>
<ListItemText primary="غير مدفوع"/>
</MenuItem>

</Select>

</FormControl>
</Grid>
<Grid item xs={12} md={3}>
<FormControl fullWidth>
  <InputLabel shrink sx={{ right: 0, left: "auto" }}>
طريقة الدفع
</InputLabel>

<Select
multiple
value={paymentMethodFilter}
onChange={(e)=>setPaymentMethodFilter(e.target.value)}
renderValue={(selected)=>
selected.map(m=>paymentMethodLabel[m] || m).join(" ، ")
}
>

<MenuItem value="deposit">
<Checkbox checked={paymentMethodFilter.indexOf("deposit") > -1}/>
<ListItemText primary="دفعة أولية"/>
</MenuItem>
<MenuItem value="deposit_cash">
<Checkbox checked={paymentMethodFilter.indexOf("deposit_cash") > -1}/>
<ListItemText primary="دفعة أولية كاش"/>
</MenuItem>

<MenuItem value="full_online">
<Checkbox checked={paymentMethodFilter.indexOf("full_online") > -1}/>
<ListItemText primary="دفع كامل أونلاين"/>
</MenuItem>

<MenuItem value="full_cash">
<Checkbox checked={paymentMethodFilter.indexOf("full_cash") > -1}/>
<ListItemText primary="دفعة كاملة كاش"/>
</MenuItem>

<MenuItem value="cash_on_delivery">
<Checkbox checked={paymentMethodFilter.indexOf("cash_on_delivery") > -1}/>
<ListItemText primary="دفع عند الاستلام"/>
</MenuItem>

</Select>
</FormControl>
</Grid>
      </Grid>
{showPaymentAnalysis && (
  <Box
    sx={{
      mt: 2,
      p: 2,
      border: "1px solid #ddd",
      borderRadius: 2,
      background: "#fafafa",
    }}
  >
    <Typography fontWeight="bold" mb={1}>
      💰 تحليل الدفعات (حسب الفلاتر)
    </Typography>

    {/* المجموع */}
    <Typography fontSize={16} fontWeight={600} mb={2}>
      إجمالي الدفعات: {totalOnlineAmount.toLocaleString()} د.ع
    </Typography>

    {/* التفصيل */}
    <Box display="flex" gap={2} flexWrap="wrap">
      <Paper sx={{ p: 2, minWidth: 120, textAlign: "center" }}>
        💳 Qi Card
        <Typography fontWeight="bold">
          {qiTotal.toLocaleString()} د.ع
        </Typography>
      </Paper>

      <Paper sx={{ p: 2, minWidth: 120, textAlign: "center" }}>
        📱 Zain Cash
        <Typography fontWeight="bold">
          {zainTotal.toLocaleString()} د.ع
        </Typography>
      </Paper>

      <Paper sx={{ p: 2, minWidth: 120, textAlign: "center" }}>
        🏦 FIB
        <Typography fontWeight="bold">
          {fibTotal.toLocaleString()} د.ع
        </Typography>
      </Paper>
    </Box>
  </Box>
)}
<Box
  display="flex"
  gap={1}
  flexWrap="wrap"
  justifyContent="flex-start"
  mb={3}
  dir="rtl"
>

  <Button
    variant={saleAccountFilter === "حساب نرسي" ? "contained" : "outlined"}
    color="secondary"
onClick={() =>
  setSaleAccountFilter(saleAccountFilter === "حساب نرسي" ? "الكل" : "حساب نرسي")
}
  >
    🧾 حساب نرسي: {totalNarcy.toLocaleString()} د.ع
  </Button>

  <Button
    variant={saleAccountFilter === "حساب استاذ مروان" ? "contained" : "outlined"}
    color="info"
onClick={() =>
  setSaleAccountFilter(saleAccountFilter === "حساب استاذ مروان" ? "الكل" : "حساب استاذ مروان")
}
  >
    🧾 حساب استاذ مروان: {totalMarwan.toLocaleString()} د.ع
  </Button>

  <Button
    variant={saleAccountFilter === "مطبعة صدى سومر - أبو زينب (زبون)" ? "contained" : "outlined"}
    sx={{ color: "#00695c", borderColor: "#00695c" }}
onClick={() =>
  setSaleAccountFilter(
    saleAccountFilter === "مطبعة صدى سومر - أبو زينب (زبون)" ? "الكل" : "مطبعة صدى سومر - أبو زينب (زبون)"
  )
}
  >
    🧾 مطبعة صدى سومر - أبو زينب (زبون): {totalSudaSumer.toLocaleString()} د.ع
  </Button>

</Box>
     <Box
  display="flex"
  gap={1}
  flexWrap="wrap"
  justifyContent="flex-start"
  mb={3}
  dir="rtl"
>
  <Button
  variant={activeStatFilter === "all" ? "contained" : "outlined"}
  onClick={() => setActiveStatFilter("all")}
>
  الطلبات الكلية | {statsAllYears.totalCount} | {statsAllYears.totalAmount.toLocaleString()} د.ع
</Button>
  <Button
    variant={saleAccountFilter === "ماركتنك" ? "contained" : "outlined"}
    color="warning"
onClick={() =>
  setSaleAccountFilter(saleAccountFilter === "ماركتنك" ? "الكل" : "ماركتنك")
}
  >
    📣 ماركتنك: {totalMarketing.toLocaleString()} د.ع
  </Button>


 





</Box>

{/* ✅ سطر سنة 2026 */}
<Box
  display="flex"
  gap={1}
  flexWrap="wrap"
  justifyContent="flex-start"
  mb={3}
  dir="rtl"
>
<Button
  variant={yearFilter === 2026 ? "contained" : "outlined"}
  onClick={() => {
    setSelectedMonth(null);
      setYearStatOwner(2026);
    setYearStatFilter("all"); // ✅ هناااا
    setYearFilter(yearFilter === 2026 ? "الكل" : 2026);
  }}
>
  📅 2026
</Button>
<Button
 variant={yearStatOwner === 2026 && yearStatFilter === "all" ? "contained" : "outlined"}
onClick={() => {
  setSelectedMonth(null);
  setYearFilter(2026);
  setYearStatOwner(2026);
  setYearStatFilter("all");
}}

>
  الطلبات الكلية | {stats2026.totalCount} | {stats2026.totalAmount.toLocaleString()} د.ع
</Button>





</Box>

{/* ✅ سطر سنة 2025 */}
<Box
  display="flex"
  gap={1}
  flexWrap="wrap"
  justifyContent="flex-start"
  mb={2}
  dir="rtl"
>
<Button
  variant={yearFilter === 2025 ? "contained" : "outlined"}
  onClick={() => {
    setSelectedMonth(null);
    setYearStatOwner(2025);
    setYearStatFilter("all"); // ✅ هناااا
    setYearFilter(yearFilter === 2025 ? "الكل" : 2025);
  }}
>
  📅 2025
</Button>



 <Button
  variant={yearFilter === 2025 && yearStatFilter === "all" ? "contained" : "outlined"}
  onClick={() => {
    setSelectedMonth(null);
    setYearFilter(2025);
    setYearStatFilter("all");
  }}
>
  الطلبات الكلية | {stats2025WithStatic.totalCount}
| {stats2025WithStatic.totalAmount.toLocaleString()} د.ع
</Button>




</Box>







     <Box
  display="grid"
  gridTemplateColumns="repeat(6, 1fr)"
  gap={2}
  mb={4}
  dir="rtl"
>

{sortedMonthEntries
  .filter(([month]) => {
    if (yearFilter === "الكل") return true;
    return month.startsWith(String(yearFilter));
  })

  .map(([month, data]) => {
  const isActive = selectedMonth === month;

  // تخصيص عرض شهر 2025-07 فقط
  const displayCount = month === "2025-07" ? 18 : data.count;
  const displayTotal = month === "2025-07" ? 9027000 : data.total;

  return (
    <Paper
      key={month}
onClick={() => {
  const year = Number(month.split("-")[0]);
  setYearFilter(year); // ✅ يخلي السنة تلقائياً حسب الشهر
    setActiveStatFilter("all");
  setSelectedMonth(isActive ? null : month);
}}
      sx={{
        p: 2,
        minWidth: 160,
        backgroundColor: isActive ? "#e3f2fd" : "#f5f5f5",
        textAlign: "center",
        border: "1px solid #ccc",
        borderRadius: 2,
        cursor: "pointer",
        transition: "0.2s",
      }}
      elevation={isActive ? 4 : 1}
    >
      <Typography fontWeight={600}>{month}</Typography>
  <Typography fontSize={14}>
  💰 {(data.total || 0).toLocaleString()} د.ع
</Typography>
{data.marketingTotal > 0 && (
  <Typography fontSize={14} color="warning.main" fontWeight={600}>
    📣 ماركتنك: {data.marketingTotal.toLocaleString()} د.ع
    {data.marketingCount > 0 && ` (${data.marketingCount} طلب)`}
  </Typography>
)}

      <Typography fontSize={14}>📦 {displayCount} طلب</Typography>
      <Typography fontSize={14} color="#6a1b9a" fontWeight={600}>
  🧩 {data.totalBoardsCount || 0} لوحة
</Typography>
   
{data.drawingOrdersCount > 0 && (
  <>
    <Typography fontSize={14} color="secondary">
      🎨 {data.drawingOrdersCount} طلبات رسم
    </Typography>

    <Typography fontSize={14} color="secondary">
      🖌️ {data.drawingBoardsCount} لوحات رسم
    </Typography>
  </>
)}
{/* 🛠️ طلبات تحتوي تركيب */}
<Typography fontSize={14} color="#1565c0" fontWeight={600}>
 🛠️ {data.assemblyOrdersCount || 0} :   تركيب 
</Typography>

<Typography fontSize={13} color="textSecondary">
  📈 معدل الطلبات: {getDailyAverage(month, data.count)} طلب/يوم
</Typography>


<Typography fontSize={13} color="green">
  ✅ تم الدفع: {(data.paid || 0).toLocaleString()} د.ع
</Typography>

<Typography fontSize={13} color="error">
  ⏳ المتبقي: {(data.remaining || 0).toLocaleString()} د.ع
</Typography>
{data.negativeCount > 0 && (
  <Typography
    fontSize={13}
    color="error.main"
    fontWeight={700}
    sx={{ mt: 0.5 }}
  >
    👎 الطلبات المرفوضة | {data.negativeCount} |{" "}
    {(data.negativeTotal || 0).toLocaleString()} د.ع
  </Typography>
)}

    </Paper>
  );
})}

        
      </Box>
{selectedMonth &&
  staticOldMonths[selectedMonth] && (
    <Box
      sx={{
        mt: 2,
        p: 2,
        border: "1px dashed #1976d2",
        borderRadius: 2,
        backgroundColor: "#f0f8ff",
      }}
    >
      <Typography variant="h6" fontWeight="bold" color="primary">
        تفاصيل شهر {selectedMonth}
      </Typography>

      <Typography>
        🟢 عدد طلبات Sales: {staticOldMonths[selectedMonth].salesCount}
      </Typography>
      <Typography>
        💰 مجموع Sales:{" "}
        {staticOldMonths[selectedMonth].salesTotal.toLocaleString()} د.ع
      </Typography>

      <Typography>
        🔵 عدد طلبات Marketing: {staticOldMonths[selectedMonth].marketingCount}
      </Typography>
      <Typography>
        💰 مجموع Marketing:{" "}
        {staticOldMonths[selectedMonth].marketingTotal.toLocaleString()} د.ع
      </Typography>
    </Box>
  )}

      {filteredOrders.map((order) => (
    <Accordion
  key={order.id}
  sx={{
    mb: 2,
    direction: "rtl",
        position: "relative", // ✅ مهم
    backgroundColor: ["تم التوصيل", "تركيب", "تم التركيب", "تم التوصيل (بعد الفيدباك)"].includes(order.status)
      ? "#d0f0c0" // ✅ أخضر فاتح (مكتملة)
      : "#ffe8cc", // برتقالي فاتح (قيد العمل)
  }}
>


           <Typography
  sx={{
    fontWeight: "bold",
    fontSize: "0.9rem",
    textAlign: "right",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  }}
>
  <span>
    🕒{" "}
    {order.createdAt?.toDate?.()
      ? `${order.createdAt.toDate().getFullYear()}-${String(
          order.createdAt.toDate().getMonth() + 1
        ).padStart(2, "0")}-${String(
          order.createdAt.toDate().getDate()
        ).padStart(2, "0")} ${String(
          order.createdAt.toDate().getHours()
        ).padStart(2, "0")}:${String(
          order.createdAt.toDate().getMinutes()
        ).padStart(2, "0")}`
      : "—"}{" "}
    | مصدر الطلب: {order.source || "غير محدد"}
    | حساب: {order.saleAccount || "بيع"}
    | طريقة الدفع: {paymentMethodLabel[order.payment?.method] || "—"}
    {order.remainingCollected && (
      <> | <span style={{ color: "#0f6b5c", fontWeight: "bold" }}>🔗 محصَّل محاسبياً</span></>
    )}

| نوع الزبون : {orderTypeLabels[order.orderType] || order.orderType || "غير محدد"}
  </span> 
 <span>
  الاسم | {order.customerName} | الحالة{" "}
{order.status === "عند برهان" && order.completedSteps?.length > 0
  ? renameStatus(`عند برهان - ${order.completedSteps[order.completedSteps.length - 1]}`)
  : renameStatus(order.status, order)}
| المحافظة {order.governorate} | السعر{" "}
  {Number(order.price).toLocaleString()} د.ع
| 🧩 عدد اللوحات: {order.boardsCount || "—"}
{order.withDrawing && (
  <> | 🎨 عدد لوحات الرسم: {order.drawingBoardsCount || "—"}</>
)}

</span>
{isPaymentVisible(order) && (
  <Box
    sx={{
      position: "absolute",
      left: 0,
      top: 0,
      height: "100%",        // 🔥 نفس ارتفاع الكارد
      width: 90,             // 🔥 مربع واضح
      backgroundColor: "#2e7d32",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderTopLeftRadius: 8,
      borderBottomLeftRadius: 8,
      boxShadow: "inset 0 0 0 2px #1b5e20",
      zIndex: 10,
    }}
  >
    <img
      src={paidIcon}        // ✅ نفس الصورة القديمة
      alt="مدفوع"
      style={{
        width: 60,
        height: 60,
        objectFit: "contain",
      }}
    />
  </Box>
)}



</Typography>

          <AccordionDetails>




{/* 🧾 فواتير الورشة (طباعة / إطارات) */}
{(order.printInvoice?.url || order.framesInvoice?.url) && (
  <Box mt={2}>
    <Typography variant="h6" color="primary">
      🧾 فواتير الطلب:
    </Typography>

    <Box display="flex" gap={2} flexWrap="wrap" mt={1}>
      {/* ✅ فاتورة الطباعة */}
      {order.printInvoice?.url && (
        <Box>
          <Typography fontWeight="bold">🖨️ فاتورة الطباعة:</Typography>

          <Box
            sx={{
              width: 140,
              height: 140,
              borderRadius: 2,
              overflow: "hidden",
              border: "1px solid #ccc",
              cursor: "pointer",
              backgroundColor: "#f5f5f5",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            onClick={() =>
              setPreviewFile({ url: order.printInvoice.url, type: "image" })
            }
          >
            <img
              src={order.printInvoice.url}
              alt="print-invoice"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
              onError={(e) => {
                // إذا كانت PDF أو ما تنعرض كصورة
                e.currentTarget.style.display = "none";
              }}
            />
            <Typography sx={{ fontSize: 12 }}>
              (إذا PDF افتح الرابط)
            </Typography>
          </Box>

          <Box mt={1}>
            <Link href={order.printInvoice.url} target="_blank" rel="noopener">
              🔗 فتح الفاتورة
            </Link>
          </Box>
        </Box>
      )}

      {/* ✅ فاتورة الإطارات */}
      {order.framesInvoice?.url && (
        <Box>
          <Typography fontWeight="bold">🖼️ فاتورة الإطارات:</Typography>

          <Box
            sx={{
              width: 140,
              height: 140,
              borderRadius: 2,
              overflow: "hidden",
              border: "1px solid #ccc",
              cursor: "pointer",
              backgroundColor: "#f5f5f5",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            onClick={() =>
              setPreviewFile({ url: order.framesInvoice.url, type: "image" })
            }
          >
            <img
              src={order.framesInvoice.url}
              alt="frames-invoice"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
              onError={(e) => {
                e.currentTarget.style.display = "none";
              }}
            />
            <Typography sx={{ fontSize: 12 }}>
              (إذا PDF افتح الرابط)
            </Typography>
          </Box>

          <Box mt={1}>
            <Link href={order.framesInvoice.url} target="_blank" rel="noopener">
              🔗 فتح الفاتورة
            </Link>
          </Box>
        </Box>
      )}
    </Box>
  </Box>
)}

            <Divider sx={{ my: 2 }} />





          
      

          </AccordionDetails>
        </Accordion>
      ))}



    </Container>
  );
};

export default AdminDashboard;
